import React from 'react'
// containers
import BusinessActivitiesContainer from 'containers/BusinessActivities'

const BusinessActivitiesSettingsPage: React.FC = () => <BusinessActivitiesContainer />

export default BusinessActivitiesSettingsPage

